import React, { useRef } from "react"
import styled from "styled-components"
import * as animationDataWhite from "@/assets/lottie/animacja-szukajka-pck-white.json"
import * as animationDataGray from "@/assets/lottie/animacja-szukajka-pck-gray.json"
import useGlobals from "@/hooks/useGlobals"
import Reveal from "@/animations/Reveal"
import dynamic from "next/dynamic"

const Lottie = dynamic(() => import("react-lottie"), { ssr: false })

const NoResultsWrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	width: 100%;
`

const LottieWrapper = styled.div`
	//max-width: 50%;
	height: 40vh;
	margin-bottom: 30px;

	&.gray {
		height: 30vh;
	}
`

const defaultOptions = {
	loop: true,
	autoplay: true,
	animationData: animationDataWhite,
	rendererSettings: {
		preserveAspectRatio: "xMidYMid slice",
	},
}

const NoResultsLottie = ({ variant = "white" }) => {
	const WrapperRef = useRef()
	const globals = useGlobals()
	const noResultsHeader = globals?.noResultsHeader || ""
	const noResultsSubheader = globals?.noResultsSubheader || ""
	defaultOptions.animationData = variant === "gray" ? animationDataGray : animationDataWhite
	return (
		<NoResultsWrapper ref={WrapperRef}>
			<LottieWrapper className={variant}>
				<Lottie options={defaultOptions} isClickToPauseDisabled ariaRole={"generic"} />
			</LottieWrapper>
			<Reveal onInView>
				<p className="typo-borna typo-borna-26">{noResultsHeader}</p>
			</Reveal>
			<Reveal onInView>
				<p className="typo-borna typo-borna-25">{noResultsSubheader}</p>
			</Reveal>
		</NoResultsWrapper>
	)
}

export default NoResultsLottie
